export class ImageDetails {
  imageUrl: string;
  thumbnailUrl: string;
  mediumUrl: string;
  micrositeThumbnailUrl: string;
  displayOrder: number;
}
